export default class OrganizationContractSettings {

    /**
     * Id of the Settings in Renta Task.
     *
     */
    public id: string | null = null;

    /**
     * Invite contact person on WO Creation for this contract if the invite has not been sent yet.
     */
    public inviteContactPerson: boolean = false;

    /**
     * Send an invitation when acceptance (Work Order) is required from the customer
     */
    public sendInvitationOnAcceptanceRequired: boolean = true;

    /**
     * Send acceptance email when required (e.g., a mounter or a manager sends an acceptance email).
     */
    public sendAcceptanceEmail: boolean = true;
}